import { Component, inject, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { MatError, MatFormField, MatLabel } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { LoginService } from '../../../core/services/Login/login.service'; 
import { Router } from '@angular/router';
import { CustomErrorStateMatcher } from '../../../core/models/CustomErrorStateMatcher';
import { AesEncDecService } from '../../../core/services/aes/aes-enc-dec.service';
import { ResponseVm } from '../../../core/models/response-vm';
import { LoginHeaderComponent } from '../../../shared/components/login-header/login-header.component'; 
import { FooterComponent } from '../../../shared/components/app-footer/footer.component'; 


@Component({
  selector: 'app-otp-page',
  standalone: true,
  imports: [CommonModule, MatLabel, FormsModule, ReactiveFormsModule, MatFormField, MatInput, MatError,
    LoginHeaderComponent,FooterComponent
  ],
  templateUrl: './otp-page.component.html',
  styleUrl: './otp-page.component.scss'
})

export class OtpPageComponent implements OnInit {
  private router = inject(Router);
  loginService = inject(LoginService);
  localStorage = inject(AesEncDecService);
  security = inject(AesEncDecService);
  matcher = new CustomErrorStateMatcher();
  otpFailedMessage: string;
  otpForm: FormGroup;
  formValues: any;
  userId: string;

  constructor(private fb: FormBuilder) {
    this.otpForm = this.fb.group({
      otp: new FormControl('', [Validators.required]),
      
    });
  }

  ngOnInit(): void {
    this.userId = JSON.parse(this.localStorage?.getData("loginUserId")?.toString() || '{}');
    this.otpForm.addControl('userID', new FormControl(this.userId));
    
  }

  receiveFormValues(values: any): void {
    this.formValues = values;
  }

  onSubmit() {
    this.formValues = this.otpForm.value;
    this.loginService.checkOtp(this.formValues).subscribe({
      next: (response: ResponseVm) => {
        if(response.responseCode=='1084'){
        this.router.navigateByUrl('reset-password');
      }
      else{
       this.otpFailedMessage=response.responseMessage;
      }
    },
      error: error => {
        this.otpFailedMessage='There was an error!'
        console.error('There was an error!', error);
      }
    });
  }

  onResendOtp(event: Event) {
    event.preventDefault();
    this.formValues = this.otpForm.value;
    this.loginService.resendOtp(this.formValues).subscribe({
      next: (response: ResponseVm) => {
         if (response.responseCode=='1000') {
           console.log('OTP resent successfully');
           this.otpFailedMessage = response.responseMessage;
        } else {
           this.otpFailedMessage = response.responseMessage;
         }
      },
      error: error => {
        this.otpFailedMessage = 'There was an error resending the OTP!';
        console.error('There was an error!', error);
      }
    });
  }
}